import React from 'react';
import { Modal, Button, Message, Icon, List } from 'semantic-ui-react';

interface EditContractWarningModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  contractCreatedAt: Date;
  notificationEmail?: string;
}

const EditContractWarningModal: React.FC<EditContractWarningModalProps> = ({
  open,
  onCancel,
  onConfirm,
  contractCreatedAt,
  notificationEmail = 'davi.custodio@getteltelecom.com'
}) => {
  const hoursSinceCreation = (Date.now() - contractCreatedAt.getTime()) / (1000 * 60 * 60);
  const daysSinceCreation = Math.floor(hoursSinceCreation / 24);
  const hoursRemaining = Math.floor(hoursSinceCreation % 24);

  return (
    <Modal open={open} onClose={onCancel} size="small">
      <Modal.Header>
        <Icon name="warning" color="orange" />
        Aviso: Edição de Contrato Antigo
      </Modal.Header>
      <Modal.Content>
        <Message warning>
          <Message.Header>Contrato criado há mais de 24 horas</Message.Header>
          <p>
            Este contrato foi criado há <strong>{daysSinceCreation} dias e {hoursRemaining} horas</strong>.
            Ao continuar com a edição, um email será enviado automaticamente ao administrador.
          </p>
        </Message>

        <Message info>
          <Message.Header>Email de notificação</Message.Header>
          <p>
            Um email será enviado para: <strong>{notificationEmail}</strong>
          </p>
        </Message>

        <Message>
          <Message.Header>Campos que podem ser editados:</Message.Header>
          <List bulleted>
            <List.Item>
              <strong>Aba Contrato:</strong> Tipo de contrato, Token, Dia de vencimento, Número P2B, Fastchip, Comprometimento mínimo
            </List.Item>
            <List.Item>
              <strong>Aba Endereço:</strong> CEP, Estado, Cidade, Endereço, Número, Complemento, Bairro, Referência
            </List.Item>
            <List.Item>
              <strong>Aba Administrador:</strong> Nome Completo, CPF, RG, Email, Telefone Principal, Telefone Secundário
            </List.Item>
            <List.Item>
              <strong>Aba Representantes:</strong> Adicionar/remover representantes, Editar CPF dos representantes
            </List.Item>
            <List.Item>
              <strong>Aba Recebedores:</strong> Adicionar/remover recebedores, Editar CPF dos recebedores
            </List.Item>
            <List.Item>
              <strong>Aba Testemunhas:</strong> Adicionar/remover testemunhas (até 2), Nome, CPF, RG
            </List.Item>
            <List.Item>
              <strong>Aba Linhas:</strong> Adicionar/editar/remover linhas, Negociação, DDD, Número, CCID, Aparelho, Tipo de Venda, Plano, Valor do Chip
            </List.Item>
          </List>
        </Message>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>
          <Icon name="cancel" />
          Cancelar
        </Button>
        <Button primary onClick={onConfirm}>
          <Icon name="checkmark" />
          Continuar com Edição
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EditContractWarningModal;

